import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from 'react';
import clsx from 'clsx';
import classes from '../GridTable.module.css';
export const Body = ({ children, className, gridTemplateColumns }) => {
    const firstChild = Children.toArray(children)[0];
    const columns = Array.isArray(firstChild?.props.children)
        ? firstChild?.props?.children
        : [firstChild?.props?.children];
    const columnsParam = (columns || [])
        .filter((el) => !!el)
        .map((el) => {
        if (!el) {
            return '';
        }
        const min = el?.props.minWidth;
        const max = el?.props.maxWidth;
        if (min || max) {
            return `minmax(${min || 'auto'}, ${max || 'auto'})`;
        }
        return el?.props.width || 'auto';
    })
        .join(' ');
    return (_jsx("div", { className: clsx(classes.body, className), style: { gridTemplateColumns: gridTemplateColumns || columnsParam }, children: children }));
};
